import React from "react";

import CreateForm from "./create form/CreateForm";
function CreateNovel({ setInterfaces, setPopUp, user }) {
  return (
    <div>
      <h1 className="flex justify-center mt-[100px] font-size text-center relative text-tertiary ">
        Create your novel
      </h1>
      <div className="mt-[50px] md:mt-[80px] ">
        <div className="max-w-[1100px] m-auto">
          <CreateForm
            user={user}
            setInterfaces={setInterfaces}
            setPopUp={setPopUp}
          />
        </div>
      </div>
    </div>
  );
}

export default CreateNovel;
